export default "__VITE_PUBLIC_ASSET__cdea991a__"